import { uploadTrack } from "shihuo-lib/dist/shihuo-lib";

let hidden;
let visibilityChange;
let awaitTimer = null;
let isSussTrigger = false;
let lock = false;

function isAndroidFunc() {
  if (typeof window === 'undefined') {
    return true;
  }
  return (
    window.navigator.userAgent.indexOf("Android") > -1 ||
    window.navigator.userAgent.indexOf("Adr") > -1
  );
}

const isAndroid = isAndroidFunc();
const isWx = typeof window !== 'undefined' ? window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger' : false;
const isQQ = typeof window !== 'undefined' ? (/MQQBrowser/i.test(window.navigator.userAgent) && /\sQQ/i.test((window.navigator.userAgent).split('MQQBrowser'))) : false;
const isWeibo = typeof window !== 'undefined' ? window.navigator.userAgent.toLowerCase().match(/WeiBo/i) == 'weibo' : false;
const browser = isWx ? 'weixin' : (isQQ ? 'qq' : (isWeibo ? 'weibo' : 'default'));
const platform = isAndroid ? 'android' : 'ios';

// App分享的原始口令
const source_kouling = getQueryString('source_kouling') || '';
const guide_from = getQueryString('guide_from') || '';

// 不同场景使用不同的统一链接
const downloadUrlMap = {
  share: {
    downloadUrlAndroid: 'https://m.malink.cn/s/YBJjim',
    downloadUrlIOS: 'https://apps.apple.com/app/apple-store/id875177200?pt=122618757&ct=m-share&mt=8'
  },
  seo: {
    downloadUrlAndroid: 'https://m.malink.cn/s/EzAjIn',
    downloadUrlIOS: 'https://apps.apple.com/app/apple-store/id875177200?pt=122618757&ct=seo-25&mt=8'
  }
}

// 获取url参数
function getQueryString(name) {
  if (typeof window == 'undefined') return null;
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]); return null;
} 


/**
 * 页面可见性API兼容不同浏览器
 */
function getSupportedProperty() {
  if (typeof document === 'undefined') return;

  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }
}

getSupportedProperty();

/**
 * 判断页面是否隐藏（进入后台）
 */
function isPageHidden() {
  if (typeof hidden === 'undefined') return false;
  return document[hidden];
}


/** 判断唤端是否成功
 * @param success - 唤端成功回调函数
 * @param failure - 唤端失败回调函数
 * @param error - 唤端异常函数
 * @param timeout - hack 失败检测延时 - 一般会触发下载
 */
function checkOpen(
  pageOptions = {},  
  success = () => {},
  failure = () => {},
  error = () => {},
  timeout = 2500
) {

  const { scene = '' } = pageOptions;

  let haveChanged = false;

  // 页面被卸载前（此时指的是未安装App跳转下载页时）
  const pageHideFunc = function(e) {
    haveChanged = true;
    
    // 唤端失败埋点上报
    uploadTrack({
      pti: {
        id: `${scene}:arouseFail:`,
        name: '',
        biz: JSON.stringify(pageOptions),
        pageOptions
      },
    });

    if (!isAndroid && !isWx && !isQQ && !isWeibo) {
      // IOS端且浏览器环境为非微信、非QQ、非微博时，会跳转下载页，此时进行endDownload埋点上报
      uploadTrack({
        pti: {
          id: `${scene}:endDownload:`,
          name: '',
          biz: JSON.stringify(pageOptions),
          pageOptions
        },
      })
    }
    failure();

    if (!isAndroid) {
      window.removeEventListener('pagehide', pageHideFunc, false); 
    }
    document.removeEventListener(visibilityChange, pageChange, false);
  }

  // 页面被切入后台运行（此时指的是已安装App，直接唤起App时）
  const pageChange = function (e) {
    haveChanged = true;

    if (document.hidden || e.hidden || document.visibilityState == 'hidden') {
      isSussTrigger = true;
      if (!isAndroid) {
        uploadTrack({
          pti: {
            id: `${scene}:arouseSuss:`,
            name: '',
            biz: JSON.stringify(pageOptions),
            pageOptions
          },
        }); 
      } else {
        // Andorid 在微信、QQ、微博浏览器中，页面重定向到引导去浏览器打开时，重定向操作也会触发pageChange方法，误认为是唤端成功，这里要进行纠正，上报唤端失败的埋点
        uploadTrack({
          pti: {
            id: (isWx || isQQ || isWeibo) ? `${scene}:arouseFail:` : `${scene}:arouseSuss:`,
            name: '',
            biz: JSON.stringify(pageOptions),
            pageOptions
          },
        }); 
      }
      success()
    } else {
      error();
    }

    if (!isAndroid) {
      window.removeEventListener('pagehide', pageHideFunc, false); 
    }
    document.removeEventListener(visibilityChange, pageChange, false);
  }

  const timer = setTimeout(() => {
    clearTimeout(timer);

    if (haveChanged) {
      lock = false;
      if (!isAndroid && isWx) {
        // IOS的微信浏览器唤端时有二次确认弹窗，页面增加了全局loading，此时需要移除全局loading
        removeGlobalLoading(); 
      }
      return;
    }

    if (!isAndroid) {
      window.removeEventListener('pagehide', pageHideFunc, false); 
    }
    document.removeEventListener(visibilityChange, pageChange, false);

    // 判断页面是否隐藏（进入后台）
    const pageHidden = isPageHidden();
    if (!pageHidden) {
      // 唤端失败埋点上报
      uploadTrack({
        pti: {
          id: `${scene}:arouseFail:`,
          name: '',
          biz: JSON.stringify(pageOptions),
          pageOptions
        },
      });
      if (!isAndroid && !isWx && !isQQ && !isWeibo) {
        // IOS端且浏览器环境为非微信、非QQ、非微博时，结束下载埋点上报
        // 原因是IOS在微信、QQ、微博中无法正常打开下载页面
        uploadTrack({
          pti: {
            id: `${scene}:endDownload:`,
            name: '',
            biz: JSON.stringify(pageOptions),
            pageOptions
          },
        })
      }
      failure();
    } else {
      error();
    }

    lock = false;
    haveChanged = true;

    if (!isAndroid && isWx) {
      // IOS的微信浏览器唤端时有二次确认弹窗，页面增加了全局loading，此时需要移除全局loading
      removeGlobalLoading(); 
    }
  }, timeout);

  if (!isAndroid) {
    // IOS端未安装App时，location.href跳转通用下载页时，会触发pagehide事件，通过此监听进行唤端失败时相关埋点的上报
    window.addEventListener('pagehide', pageHideFunc, false); 
  }
  document.addEventListener(visibilityChange, pageChange, false)
}

/*剪切板复制*/
function copyToClipBoard(input, {target = document.body} = {}) {
  const element = document.createElement('textarea');
  const previouslyFocusedElement = document.activeElement;

  element.value = input;

  // Prevent keyboard from showing on mobile
  element.setAttribute('readonly', '');

  element.style.contain = 'strict';
  element.style.position = 'absolute';
  element.style.left = '-9999px';
  element.style.fontSize = '12pt'; // Prevent zooming on iOS

  const selection = document.getSelection();
  const originalRange = selection.rangeCount > 0 && selection.getRangeAt(0);

  target.append(element);
  element.select();

  // Explicit selection workaround for iOS
  element.selectionStart = 0;
  element.selectionEnd = input.length;

  let isSuccess = false;
  try {
    isSuccess = document.execCommand('copy');
  } catch (error) {}

  element.remove();

  if (originalRange) {
    selection.removeAllRanges();
    selection.addRange(originalRange);
  }

  // Get the focus back on the previously focused element, if any
  if (previouslyFocusedElement) {
    previouslyFocusedElement.focus();
  }

  return isSuccess;
}

/**
 * 微信/QQ/微博中打开时，引导去浏览器打开
 */
function guideToBrowser() {
  const dataDpr = document.documentElement.getAttribute('data-dpr'); // 页面缩放倍数
  const body = document.getElementsByTagName("body")[0];

  const mask = document.createElement("div");
  mask.style.width = '100%';
  mask.style.height = '100%';
  mask.style.backgroundColor = 'rgba(0, 0, 0, 0.85)';
  mask.style.position = 'fixed';
  mask.style.top = 0;
  mask.style.left = 0;
  mask.style.zIndex = 1000000;
  mask.style.display = 'flex';
  mask.style.justifyContent = 'flex-end';

  let imgW = 220, imgH = 152, margR = 12;
  if (dataDpr === '2') {
    imgW = 440;
    imgH = 304;
    margR = 24;
  } else if (dataDpr === '3') {
    imgW = 660;
    imgH = 456;
    margR = 36;
  }

  mask.innerHTML = `<img src='https://static.shihuocdn.cn/admin/files/20211223/af3850c69567261cdea1b7dfdca61578.png' width='${imgW}' height='${imgH}' style='margin: 0 ${margR}px 0 0' />`;

  body.appendChild(mask);

  mask.onclick = () => {
    body.removeChild(mask)
  }
}

/**
 * 自动展示引导去浏览器打开浮层
 */
function showGuideToBrowser() {
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    const guide = url.searchParams.get('guide');
    if (guide && guide === '1' && (isWx || isQQ || isWeibo)) {
      guideToBrowser();
    }
  }
}

showGuideToBrowser();

/**
 * 安卓新用户跳转下载前的增加全局loading
 */
function addGlobalLoading() {
  const body = document.getElementsByTagName("body")[0];

  const style = document.createElement('style');  
  style.innerHTML = `
      @keyframes rotate {
          from {
              transform: rotate(0deg);  
          }
          to {
              transform: rotate(360deg);  
          }
      }  
      .call-app-loading {
          animation: rotate 1s linear infinite;
      }
  `;  

  document.head.appendChild(style); // 将样式添加到头部  

  const img = document.createElement("img");
  img.className = 'call-app-loading';
  img.src = 'https://static.shihuocdn.cn/admin/files/20241210/5fd8d7d32725a589d5cab9c4ff99960d.png';
  img.style.width = '38px';
  img.style.height = '38px';
  img.style.position = 'fixed';
  img.style.top = '50%';
  img.style.left = '50%';
  img.style.zIndex = 1000000;
  img.style.marginLeft = '-19px';
  img.style.marginTop = '-19px';

  body.appendChild(img);
}

/**
 * 移除全局loading
 */
function removeGlobalLoading() {
  const globalLoading = document.querySelector('.call-app-loading');
  if (globalLoading) {
    const body = document.getElementsByTagName("body")[0];
    body.removeChild(globalLoading);
  }
}

// 等待跳转下载埋点上报
function awaitEndDownloadTrack(scene, pageOptions) {
  return new Promise((resolve) => {
    // 结束下载埋点上报
    if (!isSussTrigger) {
      try {
        uploadTrack({
          pti: {
            id: `${scene}:endDownload:`,
            name: '',
            biz: JSON.stringify(pageOptions),
            pageOptions
          },
        });
      } catch (error) {}
  
      if (awaitTimer) {
        clearTimeout(awaitTimer);
        awaitTimer = null;
      }
      awaitTimer = setTimeout(() => {
        resolve(true);
      }, 500);
    } else {
      resolve(true);
    }
  });
}

/**
 * 当前页面重定向，展示引导浮层，引导去浏览器打开
 */
function getrReloadUrl() {
  // 获取当前页面的 URL  
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    // 获取现有的查询参数  
    const params = url.searchParams;
    // 添加或更新 guide 参数  
    params.set('guide', '1');
    params.set('guide_from', browser);
    // 更新 URL 中的查询字符串  
    url.search = params.toString();
    // 给页面重定向，保留 hash 部分  
    const reloadUrl = url.toString();
  
    return reloadUrl; 
  } else {
    return 'https://apps.apple.com/app/apple-store/id875177200?pt=122618757&ct=m-share&mt=8';
  }
}

/**
 * 场景还原方法
 * @param {*必填} targetUrl 唤端成功后，要打开的页面路由地址
 * @param {*必填} kouling 场景还原所用到的原始口令，一般通过带在页面query上或由服务端接口下发
 * @param {*选填} scene 场景，用于区分来源页面
 * @param {*选填} biz 埋点扩展字段
 * @param {*选填} timeout hack 失败检测延时
 * @param {*选填} from 来源，默认来源为分享，主要用于针对不同的来源使用对应的统一链接和营销链接
 * @param {*选填} callbackSuccess 唤端成功的回调
 * @param {*选填} callbackFailure 唤端失败的回调
 * @param {*选填} callbackError 唤端异常回调
 */
function callAppTrigger(
  targetUrl,
  kouling,
  scene,
  biz = {},
  timeout = 2500,
  from = 'share',
  callbackSuccess = () => {},
  callbackFailure = () => {},
  callbackError = () => {}
) {

  if (lock) {
    return;
  }
  lock = true;

  isSussTrigger = false;
  // 定义变量
  const timestamp = new Date().getTime();
  const m_device_id = window.localStorage.getItem('m_device_id') || '';
  const trace_id = m_device_id ? `${m_device_id}-${timestamp}` : '';
  let downloadUrlAndroid = '', downloadUrlIOS = '';

  if (kouling) {
    kouling = `1http://shihuo.cn${kouling}##${trace_id}##${scene}`;
  }

  downloadUrlAndroid = downloadUrlMap[from].downloadUrlAndroid;

  if (isWx || isQQ || isWeibo) {
    // IOS的微信、QQ、微博中因为无法直接打开统一链接，这里要对当前页面进行一次重定向，reload当前页面，同时让该页面展示引导至系统浏览器的浮层
    downloadUrlIOS = getrReloadUrl();
  } else {
    downloadUrlIOS = downloadUrlMap[from].downloadUrlIOS;
  }

  const pageOptions = {
    ua: window.navigator.userAgent,
    trace_id,
    m_device_id,
    kouling,
    scene,
    platform,
    browser,
    is_wx_tag: 0,
    mode: 'click'
  }

  // 初次分享时的原始口令存在时，一次上报，方便溯源
  if (source_kouling) {
    pageOptions['source_kouling'] = source_kouling;
  }

  // 从微信或QQ引导至系统浏览器时会携带该参数，value为wx或qq
  if (guide_from && guide_from !== browser) {
    pageOptions['guide_from'] = guide_from;
  }

  if (!isAndroid && isWx) {
    // IOS微信或QQ浏览器里，深度链接唤端会有二次确认拦截，在此把timeout延长至4.5s
    timeout = 4500;
  }

  if (biz) {
    Object.assign(pageOptions, {
      ...biz
    })
  }

  // 开始下载埋点上报
  uploadTrack({
    pti: {
      id: `${scene}:beginDownload:`,
      name: '',
      biz: JSON.stringify(pageOptions),
      pageOptions,
    },
  });

  // 检测唤端是否成功
  checkOpen(pageOptions, callbackSuccess, callbackFailure, callbackError, timeout);

  // 处理场景还原
  kouling && copyToClipBoard(kouling);  // 口令存在时，复制口令到剪切板

  const schemaBizData = {
    ua: window.navigator.userAgent,
    trace_id,
    kouling,
    scene
  }
  
  if (isAndroid) {
    if (isWx || isQQ || isWeibo) {
      // Android中当页面是在微信 / QQ / 微博中打开时，引导去浏览器打开（用页面重定向的方式，因为需要在地址上携带guide和guide_from参数）
      const reloadUrl = getrReloadUrl();
      window.location.href = reloadUrl;
    } else {
      addGlobalLoading();
      const schemaRoute = `shihuo://www.shihuo.cn?route=index&source=${encodeURIComponent(targetUrl)}&kl=${encodeURIComponent(kouling)}#${encodeURIComponent(JSON.stringify(schemaBizData))}`;
      window.location.href = schemaRoute;  // 安卓通过URL Schema 唤起App， 口令存在时，只唤起首页；口令不存在时，唤起传入的路由地址
      setTimeout(async() => {
        // 延迟3秒 跳转下载
        const awaitTrack = await awaitEndDownloadTrack(scene, pageOptions);
        window.location.href = downloadUrlAndroid;
        removeGlobalLoading();
      }, 2500);
    }
  } else {
    if (isQQ || isWeibo) {
      // IOS中 当页面是在微博中打开时，引导去浏览器打开
      guideToBrowser();
    } else {
      if (isWx) {
        // IOS微信浏览器里，深度链接唤端会有二次确认拦截，imeout延长至了4.5s，等待时间较久，增加全局loading
        addGlobalLoading();
      }
      let deeplinkDomain = 'www.shihuo.cn';
      switch (window.location.host) {
        case 'm-share.shihuo.cn':
          deeplinkDomain = 'm.shihuo.cn';
          break;
        case 'www.shihuo.cn':
          deeplinkDomain = 'm.shihuo.cn';
          break;
        case 'm.shihuo.cn':
          deeplinkDomain = 'www.shihuo.cn';
          break;
        default:
          break;
      }      
      if (kouling) {
        const transitHref = `http://${deeplinkDomain}/api/transit?source=${encodeURIComponent(
          targetUrl
        )}&target=${encodeURIComponent(downloadUrlIOS)}&kl=${encodeURIComponent(kouling)}#${encodeURIComponent(JSON.stringify(schemaBizData))}`;
        window.location.href = transitHref;
      } else {
        const transitHref = `http://${deeplinkDomain}/api/transit?source=${encodeURIComponent(
          targetUrl
        )}&target=${encodeURIComponent(downloadUrlIOS)}#${encodeURIComponent(JSON.stringify(schemaBizData))}`;
        window.location.href = transitHref;
      }
    }
  }
}

/**
 * 场景还原方法
 * @param {*必填} targetUrl 唤端成功后，要打开的页面路由地址
 * @param {*必填} kouling 场景还原所用到的原始口令，一般通过带在页面query上或由服务端接口下发
 * @param {*选填} scene 场景，用于区分来源页面
 * @param {*选填} timeout hack 失败检测延时
 * @param {*选填} callbackSuccess 唤端成功的回调
 * @param {*选填} callbackFailure 唤端失败的回调
 * @param {*选填} callbackError 唤端异常回调
 */
function callAppSchema(
  targetUrl,
  kouling,
  scene,
  biz = {},
  timeout = 5000,
  callbackSuccess = () => {},
  callbackFailure = () => {},
  callbackError = () => {}
) {

  if (!isAndroid || (isWx || isQQ || isWeibo)) {
    // IOS因为在未安装识货App时，通过schema唤端safari浏览器会提示打开的是一个无效地址，体验较差，因此不做自动唤端处理
    // 微信、QQ、微博里由于平台限制，均无法直接通过schema唤端，因此不做自动唤端处理
    return;
  }

  // 定义变量
  const timestamp = new Date().getTime();
  const m_device_id = window.localStorage.getItem('m_device_id') || '';
  const trace_id = m_device_id ? `${m_device_id}-${timestamp}` : '';

  if (kouling) {
    kouling = `1http://shihuo.cn${kouling}##${trace_id}##${scene}`;
  }

  const pageOptions = {
    ua: window.navigator.userAgent,
    trace_id,
    m_device_id,
    kouling,
    scene,
    platform,
    browser,
    is_wx_tag: 0,
    mode: 'auto'
  }

  // 初次分享时的原始口令存在时，一次上报，方便溯源
  if (source_kouling) {
    pageOptions['source_kouling'] = source_kouling;
  }

  // 从微信或QQ引导至系统浏览器时会携带该参数，value为wx或qq
  if (guide_from && guide_from !== browser) {
    pageOptions['guide_from'] = guide_from;
  }

  if (biz) {
    Object.assign(pageOptions, {
      ...biz
    })
  }

  // 非微信、非QQ、非微博浏览器里，Android自动触发一次schema路由唤端，提高唤端成功率
  // 开始下载埋点上报
  uploadTrack({
    pti: {
      id: `${scene}:beginDownload:`,
      name: '',
      biz: JSON.stringify(pageOptions),
      pageOptions,
    },
  })

  // 检测唤端是否成功
  checkOpen(pageOptions, callbackSuccess, callbackFailure, callbackError, timeout);

  window.location.href = targetUrl;
}

/**
 * 页面展示埋点上报
 * @param {*必填} ptiId 埋点ID
 * @param {*选填} biz 埋点扩展字段
 */
function pageShowTrack(ptiId = '', biz = {}) {
  const timestamp = new Date().getTime();
  const m_device_id = typeof window !== "undefined" && window.localStorage.getItem('m_device_id') || '';
  const trace_id = m_device_id ? `${m_device_id}-${timestamp}` : '';
  const scene = ptiId ? ptiId.split(':')[0] : '';
  const pageOptions = {
    ua: typeof window !== "undefined" && window.navigator.userAgent,
    trace_id,
    m_device_id,
    scene,
    platform,
    browser
  }

  // 初次分享时的原始口令存在时，一次上报，方便溯源
  if (source_kouling) {
    pageOptions['source_kouling'] = source_kouling;
  }

  // 从微信或QQ引导至系统浏览器时会携带该参数，value为wx或qq
  if (guide_from && guide_from !== browser) {
    pageOptions['guide_from'] = guide_from;
  }

  Object.assign(pageOptions, {
    ...biz
  });

  uploadTrack({
    pti: {
      id: ptiId,
      name: '',
      biz: JSON.stringify(pageOptions),
      pageOptions: pageOptions,
    },
  });
}

/**
 * 以下为微信开放标签相关代码封装
 */

class WxOpenLaunchApp {
  constructor({ options = {}, containers = [], clickEvent }) {
    this.options = options;
    this.containers = containers;
    this.shareInfo = options.shareInfo;
    this.clickEvent = clickEvent;
    // 埋点上报基础字段
    this.pageOptions = {
      m_device_id: typeof window !== 'undefined' && window.localStorage.getItem('m_device_id') || '',
      ua: typeof window !== 'undefined' && window.navigator.userAgent,
      scene: options.scene,
      trace_id: '',
      kouling: '',
      platform,
      browser,
      is_wx_tag: 1,
      mode: 'click',
    }
    // 点击时间（用于拼接在trace_id的后面）
    this.clickTime = new Date().getTime();
  }

  // wx-open-launch-app 初始化配置
  async initConfig() {
    if (typeof window === 'undefined') {
      return;
    }
    if (!window.wx) {
      throw new Error('未获取到微信JS-SDK');
    }

    let wxKeyInfo;
    try {
      const { status, data } = await this.getWxKeyInfo();
      if (status !== 0) {
        return;
      }
      wxKeyInfo = data;
    } catch (error) {
      return; // 直接返回，不执行后续代码
    }

    const { appId, timestamp, nonceStr, signature } = wxKeyInfo;
    
    window.wx.config({
      debug: false,
      appId,
      timestamp, 
      nonceStr,
      signature,
      jsApiList: ['checkJsApi', 'updateAppMessageShareData', 'updateTimelineShareData'],
      openTagList: ['wx-open-launch-app']
    });

    window.wx.ready(() => {
      window.wx.checkJsApi({
        jsApiList: ['wx-open-launch-app'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function (res) {

        },
        fail: function(err) {

        }
      });

      if (this.shareInfo && typeof window !== 'undefined') {
        // 自定义二次分享给好友的卡片信息
        window.wx.updateAppMessageShareData(this.shareInfo);
        // 自定义二次分享到朋友圈的卡片信息
        window.wx.updateTimelineShareData(this.shareInfo);
      }

      this.createWxOpenLaunchAppTag();

    });

  }

  // 批量创建 wx-open-launch-app 标签
  createWxOpenLaunchAppTag() {
    if (!this.containers || this.containers.length < 0) {
      throw new Error('必须通过containers给wx-open-launch-app指定容器元素');
    }
    for (let index = 0; index < this.containers.length; index++) {
      const item = this.containers[index];
      if (item && item.element) {
        // 获取 wx-open-launch-app 的父级容器元素
        const container = document.querySelector(`${item.element}`);
        if (!container) {
          // 若指定的容器元素不存在，跳出，继续遍历下一个
          continue;
        }

        // 创建一个 wx-open-launch-app 标签，并添加属性
        const wxtag = document.createElement('wx-open-launch-app');
        // 设置 wx-open-launch-app 标签的唯一ID
        const elementId = `wx-open-launch-app-${index + 1}`;
        // 设置要还原的路由地址
        const m_device_id = typeof window !== 'undefined' && window.localStorage.getItem('m_device_id') || '';
        const trace_id = m_device_id ? `${m_device_id}-${this.clickTime}` : '';
        let { kouling, scene, targetUrl } = this.options;
        if (kouling) {
          kouling = `1http://shihuo.cn${kouling}##${trace_id}##${scene}`;
        }
        const schemaBizData = {
          ua: typeof window !== 'undefined' && window.navigator.userAgent,
          trace_id,
          kouling,
          scene
        }
        const schemaRoute = `shihuo://www.shihuo.cn?route=index&source=${encodeURIComponent(targetUrl)}&kl=${encodeURIComponent(kouling)}#${encodeURIComponent(JSON.stringify(schemaBizData))}`;
        // 设置 wx-open-launch-app 标签的其他属性
        wxtag.setAttribute('id', elementId);
        wxtag.setAttribute('appid', 'wx84d36ea0d36f05ec');
        wxtag.setAttribute('extinfo', schemaRoute);

        if (item.style) {
          // 设置 wx-open-launch-app 标签的样式
          Object.assign(wxtag.style, {
            ...item.style
          });
        }

        // 获取开放标签父节点的实际渲染宽高，作为开放标签的实际宽高
        const { width, height } = container.getBoundingClientRect();

        // 创建内部模板
        const template = document.createElement('script');
        template.type = 'text/wxtag-template';
        template.innerHTML = `
          <style>.btn { width: ${width}px; height: ${height}px; background-color: transparent; border: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }</style>
          <button class="btn"></button>
        `;

        // 内部模版添加到 wx-open-launch-app 标签元素中
        wxtag.appendChild(template);

        // 将 wx-open-launch-app 元素添加到容器元素中
        container.appendChild(wxtag);

        // 给 wx-open-launch-app 标签添加事件监听
        this.wxTagAddEventListener(elementId, item);
      }
    }
  }

  // 批量给 wx-open-launch-app 标签添加事件监听
  wxTagAddEventListener(elementId, element) {
    const btn = document.getElementById(elementId);
    btn.addEventListener('ready', (e) => {

    });
    btn.addEventListener('launch', (e) => {
      const bizData = this.getTrackBizData();
      uploadTrack({
        pti: {
          id: `${bizData.scene}:arouseSuss:`,
          name: '',
          biz: JSON.stringify(bizData),
          pageOptions: bizData
        },
      });
    });
    btn.addEventListener('error', (e) => {
      const bizData = this.getTrackBizData();
      // 唤端失败埋点上报
      uploadTrack({
        pti: {
          id: `${bizData.scene}:arouseFail:`,
          name: '',
          biz: JSON.stringify(bizData),
          pageOptions: bizData
        },
      });
      
      // 唤端失败，引导去浏览器打开（用页面重定向的方式，因为需要在地址上携带guide和guide_from参数）
      const reloadUrl = getrReloadUrl();
      window.location.href = reloadUrl;
    });
    btn.addEventListener('click', (e) => {
      // 自定义点击事件触发
      e.stopPropagation();

      copyToClipBoard(this.options.kouling); // 执行复制

      element.clickEvent && element.clickEvent();
      this.clickEvent && this.clickEvent();

      const bizData = this.getTrackBizData();
      // 开始下载埋点上报
      uploadTrack({
        pti: {
          id: `${bizData.scene}:beginDownload:`,
          name: '',
          biz: JSON.stringify(bizData),
          pageOptions: bizData,
        },
      });

    });
  }

  // 获取埋点上报字段信息
  getTrackBizData() {
    let { kouling, scene, pageOptions } = this.options;
    const m_device_id = typeof window !== 'undefined' && window.localStorage.getItem('m_device_id') || '';
    const trace_id = m_device_id ? `${m_device_id}-${this.clickTime}` : '';

    if (kouling) {
      
      kouling = `1http://shihuo.cn${kouling}##${trace_id}##${scene}`;

      copyToClipBoard(kouling); // 执行复制 
    }

    const bizData = JSON.parse(JSON.stringify(this.pageOptions));
    bizData['trace_id'] = trace_id;
    bizData['kouling'] = kouling;

    if (pageOptions) {
      Object.assign(bizData, {
        ...pageOptions
      });
    }

    return bizData;
  }

  // 获取微信开放标签注入配置所需要的配置信息
  async getWxKeyInfo() {
    try {
      const response = await window.fetch(`//sh-gateway.shihuo.cn/v4/services/sh-advertiseapi/wx/key_info?url=${encodeURIComponent(window.location.href)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      throw error;
    }
  }
}

if (typeof window !== 'undefined') {
  window.WxOpenLaunchApp = WxOpenLaunchApp; 
}

export {
  callAppTrigger,
  callAppSchema,
  pageShowTrack
}


// WEBPACK FOOTER //
// ./utils/callAppLib.js